var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKuponi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1312",
    "data-name": "Group 1312",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 28,
    height: 20,
    fill: "#004c97"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1312-2",
    "data-name": "Group 1312",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M27,8a1,1,0,0,0,1-1V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V7A1,1,0,0,0,1,8a2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V13a1,1,0,0,0-1-1,2,2,0,0,1,0-4m-1,5.87V18H19V15H17v3H2V13.87A4,4,0,0,0,2,6.13V2H17V5h2V2h7V6.13a4,4,0,0,0,0,7.74",
    fill: "#004c97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 2,
    height: 6,
    transform: "translate(17 7)",
    fill: "#004c97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuponi);
export default __webpack_public_path__ + "static/media/kuponi.6c666f1a70fb116787c1078377ebb82c.svg";
export { ForwardRef as ReactComponent };